import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import axios from "axios";
import serialize from "form-serialize";
import FooterOne from "../../common/footer/FooterOne";
import { useTranslation } from 'react-i18next';

const Result = ({ result, setResult }) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="alert alert-success text-center" role="alert">
                <h4 className="alert-heading text-center" style={{fontSize: '2.4rem'}}>{t('contactForm.result.heading')}</h4>
            </div>
            <br />
            <br />
            <p>
                {t('contactForm.result.thankYou')}<br/>
                <strong>{t('contactForm.result.ticketInfo', { code: result })}</strong>
                <br/>
                <br/>
                {t('contactForm.result.followUp')}
                <br/>
                <br/>
                {t('contactForm.result.moreHelp')} <a href={'tel:+3613009105'}>+36-1-300-91-05</a> {t('contactForm.result.byPhone')} {t('contactForm.result.or')} {t('contactForm.result.byEmail')} <a href={'mailto:support@happygastro.hu'} target={'_blank'} rel="noreferrer">support@happygastro.hu</a>.
            </p>
            <br />
            <div className="col-lg-12" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <button className="rn-btn edu-btn w-100" type="submit" onClick={() => setResult(false)}>
                    <i className="icon-arrow-left-line-right"></i><span>{t('contactForm.newMessage')}</span></button>
            </div>
        </div>
    )
}

function ContactUsForm( { formStyle, modalMode = false } ) {
    const { t } = useTranslation();
    const [result, setResult] = useState( false );

    const sendEmail = ( e ) => {
        e.preventDefault();

        // Ensure the form has the correct id
        let form = document.querySelector('#contact-us-form-');
        if (modalMode) {
            form = document.querySelector('#contact-us-form-fromModalFrom');
        }
        if (!form) {
            console.error("Form with id 'contact-us-form-' or 'contact-us-form-fromModalFrom' not found.");
            return;
        }

        // Serialize the form data
        let formData = serialize(form, { hash: true, empty: true });
        //debugg log
        // console.log("Serialized formData:", formData);

        // Check if formData is empty
        if (Object.keys(formData).length === 0) {
            console.error("Form data is empty. Ensure all input fields have the correct 'name' attributes.");
            return;
        }

        // Validate phone number
        const phoneNumber = formData.phone.replace(/\D/g, ''); // Remove non-digit characters
        if (phoneNumber.length !== 10 && phoneNumber.length !== 11) {
            alert(t('contactForm.validation.invalidPhone'));
            return;
        }
        // Validate email
        if (formData.email.includes('@') && formData.email.includes('.')) {
            const atIndex = formData.email.indexOf('@');
            const dotIndex = formData.email.lastIndexOf('.');
            if (atIndex === -1 || dotIndex === -1 || dotIndex <= atIndex + 1) {
                alert(t('contactForm.validation.invalidEmail'));
                return;
            }
        }else{
            alert(t('contactForm.validation.invalidEmail'));
            return;
        }
        //debugg log
        // console.log("data", {
        //              ...formData,
        //              origin: 'happygastro.hu',
        //              companyData: {
        //                  nev: formData.company || ""
        //              },
        //              company: formData.company || "",
        //          })

        axios({
            method: 'post',
            url: `https://api.happygastro.org/api/contact/submit`,
            headers: { 'Content-Type': 'application/json' },
            data: {
                ...formData,
                origin: 'happygastro.hu',
                companyData: {
                    nev: formData.company || ""
                },
                company: formData.company || "",
            }
        })
            .then(res => {
                e.target.reset();
                setResult(res.data.code)
            })
            .catch(error => {
                setResult(false)
                alert(t('contactForm.submitError'))
            })
    };

    let idMod = "";
    if (modalMode) {
        idMod = "fromModalFrom"
    }
    return (
        <div>
            {result ? <Result setResult={setResult} result={result} /> : <form id={`contact-us-form-${idMod}`} className={`${formStyle}`} action="" onSubmit={sendEmail}>
                <div className="col-lg-12">
                <div className="form-group">
                    <input type="text" className="form-control form-control-lg" name="fullname" placeholder={t('contactForm.placeholders.fullName')} required />
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <input type="email" className="form-control form-control-lg" name="email" placeholder={t('contactForm.placeholders.email')} required />
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <input type="text" className="form-control form-control-lg" name="company" placeholder={t('contactForm.placeholders.company')}  />
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <InputMask
                        className="form-control form-control-lg"
                        autoComplete="new-password"
                        name="phone"
                        id="phone"
                        mask="+36 (99) 999-9999"
                        placeholder={t('contactForm.placeholders.phone')}
                        required />
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <input type="text" className="form-control form-control-lg" name="subject" placeholder={t('contactForm.placeholders.subject')} required />
                </div>
            </div>
            <div className="col-lg-12">
                <div className="form-group">
                    <textarea className="form-control" name="message" placeholder={t('contactForm.placeholders.message')} required></textarea>
                </div>
            </div>
            <div className="col-lg-12">
                <button className="rn-btn edu-btn w-100" type="submit">
                    <span>{t('contactForm.placeholders.submitCta')}</span><i className="icon-arrow-right-line-right"></i></button>
            </div>
        </form>}
        </div>
    )
}
export default ContactUsForm;